import {CART_UPDATED} from "./actionTypes";

const initialState = {
    items: []
};

const cart = (state = initialState, action) => {
    switch (action.type) {
        case CART_UPDATED:
            state = {
                ...state,
                items: action.payload
            };
            break;
        default:
            state = {...state};
            break;
    }
    return state;
};

export default cart;
